import { useCallback, useMemo } from 'react';

import { useAppDispatch, useAppSelector } from '@/store';
import { selectUploadProgressEntries } from '@/store/selectors/poc/uploadProgressSelectors';
import { clearUploadProgress } from '@/store/slices/poc/heliaSlice';
import { retryFileAnnouncementThunk } from '@/store/thunks/poc/helia';

export function useSixDetailUploadProgress(sixId: string) {
  const dispatch = useAppDispatch();
  const allUploadProgressEntries = useAppSelector(selectUploadProgressEntries);

  const inFlightUploads = useMemo(
    () => allUploadProgressEntries.filter((entry) => entry.sixId === sixId),
    [allUploadProgressEntries, sixId],
  );

  const handleUploadRetry = useCallback((uploadId: string): void => {
    void dispatch(retryFileAnnouncementThunk({ uploadId }));
  }, [dispatch]);

  const handleUploadProgressComplete = useCallback((uploadId: string): void => {
    dispatch(clearUploadProgress(uploadId));
  }, [dispatch]);

  return {
    state: {
      inFlightUploads,
    },
    handlers: {
      handleUploadRetry,
      handleUploadProgressComplete,
    },
  };
}
